<script setup lang="ts">
import 'swiper/css'
import { Swiper, SwiperSlide } from 'swiper/vue'

const { company } = useCompany()
</script>

<template>
  <div v-if="company.image_grid" class="relative z-0 justify-center gap-4">
    <swiper class="!overflow-visible" slidesPerView="auto" grabCursor centeredSlides>
      <swiper-slide
        v-for="({ image }, i) in company.image_grid"
        :key="image.id"
        :initialSlide="4"
        :index="i"
        :style="{ height: 'auto !important', width: 'auto !important' }"
        class="mr-8"
      >
        <NuxtImg
          :src="image.url"
          :height="image.formats?.medium.height"
          :width="image.formats?.medium.width"
          fit="cover"
          :alt="image.alternativeText || image.name"
          class="bordershadow-lg-gray hover:border-main-600 h-full max-h-72 w-auto rounded-lg object-cover hover:h-60 md:max-h-96 lg:max-h-[36rem]"
        />
      </swiper-slide>
    </swiper>
  </div>
</template>
